module.exports = __webpack_public_path__ + "static/media/icon-social2.6604a4e0.svg";